import React from "react";
import LandingPage from './pages/landing-page';

const Routes = () => {
  console.log("Routes component is rendering");
  
  return <LandingPage />;
};

export default Routes;
